import React from "react";
import { css } from "react-emotion";

import { withRedux } from "helpers";

import { flatWrapper } from "appStyles";

const backgroundStyle = css`
  ${flatWrapper};
  background: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 15px;
`;

class Background extends React.Component {
  render() {
    const {
      activeTemplate: { backgroundColor, backgroundImage },
    } = this.props;

    let style = {
      background: backgroundColor ? backgroundColor : "#FFFFFF",
    };

    if (backgroundImage && backgroundImage.url) {
      style = {
        backgroundImage: `url(${backgroundImage.url})`,
      };
    }

    return <div className={backgroundStyle} style={style} />;
  }
}

export default withRedux(Background);
